import { classNames } from "@result/rui/utils/component";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";

const ActionButton = ({
  title,
  description,
  onClick,
  icon,
  disabled,
  className,
  iconColor,
  iconBackgroundColor,
  tag,
  to,
}) => {
  const { t } = useTranslation();

  const iconClassName = useMemo(() => {
    return classNames(
      iconColor ? `has-text-${iconColor}` : undefined,
      iconBackgroundColor ? `has-background-${iconBackgroundColor}` : undefined
    );
  }, [iconColor, iconBackgroundColor]);

  const content = (
    <>
      {icon != null && (
        <div className={classNames("action-button-icon", iconClassName)}>
          <span
            className={classNames(
              "icon is-size-5 has-text-weight-normal",
              icon
            )}></span>
        </div>
      )}
      <div className="action-button-text">
        <div className="is-size-6">{title}</div>
        <div className="is-size-7 has-text-grey">{description}</div>
        {tag != null && (
          <span className="tag is-light is-rounded mt-1">{tag}</span>
        )}
      </div>
    </>
  );

  const commonProps = {
    className: classNames("action-button", className, {
      "has-tooltip": onClick == null && !to,
      "is-disabled": disabled,
    }),
    "data-tooltip":
      onClick == null && !to ? t("featureBeingImplemented") : null,
  };

  if (to) {
    return (
      <NavLink {...commonProps} to={to}>
        {content}
      </NavLink>
    );
  }

  return (
    <div {...commonProps} onClick={disabled ? undefined : onClick}>
      {content}
    </div>
  );
};

export default ActionButton;
